import React, { useEffect, useState } from "react";
import UserImg from "../images/user-1.png";
import { Link, useLocation } from "react-router-dom";
import StickyBox from "react-sticky-box";
import Functions from "../../utility/services/Functions";

const PatientSidebar = () => {
  const location = useLocation();
  const [url, setUrl] = useState(null);
  const { logOut } = Functions();

  useEffect(() => {
    setUrl(location.pathname);
  }, [location]);

  return (
    <StickyBox offsetTop={20} offsetBottom={20} className="stickBox">
      <div className="usersidebar box-static">
        <div className="settings-header d-flex align-items-center">
          <Link>
            <img alt="" src={UserImg} className="avatar-lg rounded-circle" />
          </Link>
          <div className="ms-3">
            <p className="mb-1">Welcome</p>
            <h3 className="mb-0">Andrew James</h3>
          </div>
        </div>
        <ul className="nav flex-column">
          <li className="nav-item">
            <Link
              className={"nav-link" + (url === "/dashboard" ? " active" : "")}
              to="/dashboard"
            >
              Appointments
            </Link>
          </li>
          <li className="nav-item">
            <Link
              className={"nav-link" + (url === "/chat" ? " active" : "")}
              to="/chat"
            >
              Messages
            </Link>
          </li>
          <li className="nav-item">
            <Link
              className={
                "nav-link" +
                (url === "/patientnotificationsettings" ? " active" : "")
              }
              to="/notificationsettings"
            >
              Notification Settings
            </Link>
          </li>
          <li className="nav-item">
            <Link
              className={
                "nav-link" + (url === "/patientfavourite" ? " active" : "")
              }
              to="/patientfavourite"
            >
              Favorites
            </Link>
          </li>
          <li className="nav-item">
            <Link
              className={
                "nav-link" + (url === "/paymentsettings" ? " active" : "")
              }
              to="/paymentsettings"
            >
              Payment Information
            </Link>
          </li>
          {/* <li className="nav-item">
            <Link
              className={
                "nav-link" + (url === "/atientEditProfile" ? " active" : "")
              }
              to="/patientEditProfile"
            >
              Profile Settings
            </Link>
          </li> */}
          <li className="nav-item">
            <Link
              className="nav-link"
              as="button"
              onClick={() => {
                logOut();
              }}
            >
              Log Out
            </Link>
          </li>
        </ul>
      </div>
    </StickyBox>
  );
};

export default PatientSidebar;
